import { render, staticRenderFns } from "./VehicleUserDetails.vue?vue&type=template&id=1c06b622&scoped=true"
import script from "./VehicleUserDetails.vue?vue&type=script&lang=js"
export * from "./VehicleUserDetails.vue?vue&type=script&lang=js"
import style0 from "./VehicleUserDetails.vue?vue&type=style&index=0&id=1c06b622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c06b622",
  null
  
)

export default component.exports